import { render } from "./salesforce-webchat.vue?vue&type=template&id=53326c62"
import script from "./salesforce-webchat.vue?vue&type=script&lang=js"
export * from "./salesforce-webchat.vue?vue&type=script&lang=js"

import "./salesforce-webchat.vue?vue&type=style&index=0&id=53326c62&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__